ValidationEngine = App.loadClass 'core::ValidationEngine'

class exports.Contracts_Handler extends Handler

    init: () ->
        @layoutUrl = 'backend/portal/contracts/load-layout'

        @layoutSelector = App.sidebar.contentDiv()
        @singleSubHandler = false

        @filterParams = {}

        @subHandlers =
            'Add':
                'class': 'portal::handlers/contracts/Contracts_Add_Handler'
            'Edit':
                'class': 'portal::handlers/contracts/Contracts_Edit_Handler'
            'EditSelect':
                'class': 'portal::handlers/contracts/Contracts_Edit_Select_Handler'
            'ContractDialog':
                'class': 'portal::handlers/contracts/Contracts_Contract_Dialog_Handler'

        @loadLayout()

        @validator = new ValidationEngine()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        ths = this
        @defaultSub = 'Add'

        handler = @createSubHandler(@defaultSub)
        if handler
            handler.init()

        @dlg_handler = @createSubHandler('ContractDialog')
        if @dlg_handler
            @dlg_handler.init()

        $('a[data-toggle="tab"]').on 'shown', (e) =>
            $('#span_total_acres').text('0.00')
            @destroyHandlers()
            @resetDialogSelects()
            if $(e.target).html() is 'Edit'
                @currMode = 'Edit'
                @disableDialogForm()
            else
                @currMode = 'Add'
                @enableDialogForm()


    destroyHandlers: () ->
        for name, handler of @activeSubHandlers
            if name isnt @subHandlers['ContractDialog'].class
                handler.destroy()


    resetDialogSelects: () ->
        @dlg_handler.dialog.find('#sel_contracted_fields').html('')
        @dlg_handler.dialog.find('#sel_fields').html('')
        @dlg_handler.dialog.find('#sel_grower').val('')


    unloadContract: () ->
        @destroyHandlers()
        handler = @createSubHandler('Edit')
        if handler
            @disableDialogForm()
            handler.init()


    loadContract: (id) ->
        @destroyHandlers()
        handler = @createSubHandler('EditSelect')
        if handler
            @enableDialogForm()
            handler.loadLayoutPostOptions = id: id
            handler.init()


    disableDialogForm: () ->
        @dlg_handler.disableForm()


    enableDialogForm: () ->
        @dlg_handler.enableForm()


    makeValidation: (message) ->
        @validator.makeFormValidator 'contracts_sidebar', '#form_contracts_add_edit', '#contracts_sidebar_errors', (valid) =>
            if valid
                # don't save yet - the dialog will save all the data if valid
                if @dlg_handler.validator.validateForm('contracts_dialog')
                    @unloadContract()
                    @resetDialogSelects()
                    # @loadLayout()
                    handler = @createSubHandler('Add')
                    if handler
                        handler.init()

        @validator.registerRule
            'selector': '.validate-contract-number'
            'text': 'Contract number must be 8 digits in length'
            'func': (elem) ->
                val = $(elem).val().replace /\s-\s/g, ''
                return val.length is 8

        @validator.registerRule
            'selector': '.validate-sales-zone'
            'text': 'Please select a sales Zone'
            'func': (elem) ->
                val = $(elem).val()
                return val > 0
